import React from 'react';
import { motion } from 'framer-motion';
import { SectionDivider } from './Icons';
export function AuthorSection() {
  return <section className="py-8 px-4 md:px-8 bg-white" data-id="element-39">
      <div className="max-w-3xl mx-auto" data-id="element-40">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="flex flex-col md:flex-row items-center gap-8 bg-brand-cream rounded-2xl p-6 md:p-8 border border-brand-gold/20" data-id="element-41">
          <div className="flex-shrink-0" data-id="element-42">
            <img src="https://cdn.magicpatterns.com/uploads/sPxY8MTQPQTyVyAsoQYWYF/Imagen_autora.png" alt="Elena Vargas" className="w-40 h-40 md:w-48 md:h-48 rounded-full object-cover shadow-lg border-4 border-white" data-id="element-43" />
          </div>
          <div className="text-center md:text-left space-y-3" data-id="element-44">
            <h2 className="text-2xl md:text-3xl font-serif font-bold text-brand-green" data-id="element-45">
              Soy Elena Vargas.
            </h2>
            <p className="text-base md:text-lg text-brand-charcoal/85 leading-relaxed" data-id="element-46">
              Especialista en salud metabólica femenina y nutrición hormonal.
              Llevo 8 años acompañando a mujeres de 40+ a recuperar su energía,
              su sueño y su cuerpo — sin dietas de castigo ni soluciones de una
              talla para todas.
            </p>
            <p className="text-base md:text-lg text-brand-charcoal/85 leading-relaxed font-medium" data-id="element-47">
              He trabajado con más de 1,200 mujeres hispanohablantes en Estados
              Unidos y Latinoamérica.
            </p>
          </div>
        </motion.div>
        <SectionDivider data-id="element-48" />
      </div>
    </section>;
}